
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';

@Component

export default class InsuranceNoModal extends Vue {
  visible = false;

  @lazyInject(OrderService)
  orderService!: OrderService;

  insuranceNo = '';

  orderId = '';

  init(val: any) {
    console.log(val);
    this.insuranceNo = val.insuranceNo || '';
    this.orderId = val.orderId;
    this.visible = true;
  }

  async handleOk() {
    const res = await this.orderService.postEditInsurance(this.orderId, {
      insurance_no: this.insuranceNo,
    });
    if (res) {
      this.$message.success('修改成功');
      this.visible = false;
      this.$emit('refresh');
    }
  }

  handleCancel() {
    this.visible = false;
  }
}

